import styled from "styled-components";

export const HTMLView = styled.div`
  height: 50vh;
  overflow: auto;
`;
